import { getCircuitHealth, getHealthStatusCode } from "./registry";

export function buildCircuitHealthBody(): {
  body: ReturnType<typeof getCircuitHealth>;
  status: number;
} {
  const body = getCircuitHealth();
  return {
    body,
    status: getHealthStatusCode(body),
  };
}
